import { FormControl } from "@mui/material";

import { Availability } from "../../../apiHooks";
import { ProductQuery } from "../../../apiHooks/graphql";
import { AvailabilityContact } from "../AvailabilityContact";
import { AvailabilityDatePaxModalHeader } from "../AvailabilityDatePaxModalHeader";
import { AvailabilityDatePicker } from "../AvailabilityDatePicker";
import { AvailabilityHotelModalHeader } from "../AvailabilityHotelModalHeader";
import { AvailabilityPass } from "../AvailabilityPass";

type InternalAvailabilityModalContentHeaderProps = {
    product?: ProductQuery["product"];
    availabilityListItemId: string | null;
    initialAvailability?: Availability;
    onAvailabilityChange: (availability: string | null | undefined) => void;
};

export const InternalAvailabilityModalContentHeader = (props: InternalAvailabilityModalContentHeaderProps) => {
    const { product } = props;

    const noProduct = !product || !!product.isOffSale;
    if (noProduct || (product.availabilityType === "EXTERNAL_WIDGET" && product.externalWidgetData)) {
        return null;
    }
    const { availabilityListItemId, initialAvailability, onAvailabilityChange } = props;

    if (["SEVEN_ROOMS", "LIGHTSPEED"].includes(product.sourceInstance!.sourceName!)) {
        return (
            <AvailabilityDatePaxModalHeader
                product={product}
                selectedAvailabilityId={availabilityListItemId}
                onChange={onAvailabilityChange}
            />
        );
    }

    if (product.availabilityType === "PASS") {
        return <AvailabilityPass productId={product.id} onAvailabilityUpdated={onAvailabilityChange} />;
    }

    if (product.availabilityType === "CONTACT") {
        return <AvailabilityContact product={product} />;
    }

    if (product.availabilityType === "DATE") {
        if (product.type === "HOTEL") {
            return <AvailabilityHotelModalHeader product={product} onChange={onAvailabilityChange} />;
        }

        return (
            <FormControl fullWidth>
                <AvailabilityDatePicker
                    productId={product.id}
                    availabilityListItemId={availabilityListItemId}
                    initialAvailability={initialAvailability}
                    onChange={onAvailabilityChange}
                />
            </FormControl>
        );
    }

    throw new Error(`Unknown availability type: ${product.availabilityType}. Product data: ${JSON.stringify(product)}`);
};
